// お知らせの既読機能を管理するJavaScript
$(document).on('turbolinks:load', function () {
  // 閉じるボタンのクリックイベント
  $(document).on('click', function(e) {
    // クリックされた要素自身または親に.close-notice-btnがあるか判定
    const btn = e.target.closest('.close-notice-btn');
    if (btn) {
      const noticeId = btn.getAttribute('data-notice-id');
      closeNotice(noticeId);
    }
  });
});

// お知らせを閉じる
function closeNotice(noticeId) {
  const noticeElement = document.querySelector(`.top-notice [data-notice-id="${noticeId}"]`).closest('.top-notice');

  // アニメーション付きで要素を非表示
  noticeElement.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
  noticeElement.style.opacity = '0';
  noticeElement.style.transform = 'translateY(-10px)';

  setTimeout(() => {
    noticeElement.remove();
  }, 300);

  // 既読情報をサーバーに保存
  markAsRead(noticeId);
  updateUnreadBadge();
}

// 未読バッジをデクリメントする（楽観的更新）
function updateUnreadBadge() {
  const badges = document.querySelectorAll('.notice-unread-badge');
  badges.forEach(function(badge) {
    const count = parseInt(badge.textContent, 10);
    if (isNaN(count) || count <= 1) {
      badge.remove();
    } else {
      badge.textContent = count - 1;
    }
  });
}

// 既読情報をサーバーに保存
function markAsRead(noticeId) {
  // AJAXでDBに既読情報を保存
  fetch('/api/notice_mark_as_read', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    },
    body: JSON.stringify({ notice_id: noticeId })
  }).catch(error => {
    console.error('既読情報の保存に失敗しました:', error);
  });
} 